import { SignalStoreBuilder } from "src/app/_stores/SignalStoreBuilder";
import {
  BatteryRevision,
  IBatteryRevision,
} from "src/app/_models/location/battery/BatteryRevision";

type BatteryRevisionsMap = {
  id_battery: number;
  revisions: BatteryRevision[];
  loading: boolean;
};

export const SignalBatteryRevisionsStore =
  new SignalStoreBuilder<BatteryRevisionsMap>(
    (entry) => entry.id_battery,
    (json) => ({
      id_battery: json["id_battery"] as number,
      revisions: (json["revisions"] as IBatteryRevision[]).map(
        (r) => new BatteryRevision(r),
      ),
      loading: false,
    }),
  )
    .withMethod(
      "loadRevisions",
      (_store, http, { upsert }) =>
        async (id_battery: number) => {
          upsert({
            id_battery,
            revisions: _store.entityMap()[id_battery]?.revisions ?? [],
            loading: true,
          });
          const response = await http.get(`batteries/${id_battery}/revisions`, {
            hideLoader: true,
          });
          upsert({
            id_battery,
            revisions: response
              ? (response as any as IBatteryRevision[]).map(
                  (r) => new BatteryRevision(r),
                )
              : (_store.entityMap()[id_battery]?.revisions ?? []),
            loading: false,
          });
        },
    )
    .withMethod(
      "addRevision",
      (_store, http, { upsert }) =>
        async (data: {
          id_battery: number;
          id_version_to: number;
          notes: string | null;
        }): Promise<boolean> => {
          const response = await http.post("batteries/revisions", data);
          if (!response) return false;
          const existing = _store.entityMap()[data.id_battery]?.revisions ?? [];
          upsert({
            id_battery: data.id_battery,
            revisions: [
              new BatteryRevision(response as IBatteryRevision),
              ...existing,
            ],
            loading: false,
          });
          return true;
        },
    )
    .withMethod(
      "deleteRevision",
      (_store, http, { upsert }) =>
        async (id_revision: number, id_battery: number): Promise<boolean> => {
          const response = await http.delete(
            `batteries/revisions/${id_revision}`,
          );
          if (response === null) return false;
          const existing = _store.entityMap()[id_battery]?.revisions ?? [];
          upsert({
            id_battery,
            revisions: existing.filter((r) => r.id_revision !== id_revision),
            loading: false,
          });
          return true;
        },
    )
    .providedInRoot()
    .build();
